import { useLocation } from 'react-router-dom';

type UseQueryParamsReturn = {
  get: (param: string) => string | null;
};

const useQueryParams = (): UseQueryParamsReturn => {
  const { search } = useLocation();

  const get = (param: string) => {
    const params = new URLSearchParams(search);
    return params.get(param);
  };

  return { get };
};

export default useQueryParams;
